import axios from 'axios';

console.log("process.env.REACT_APP_API",process.env.REACT_APP_API)
const defaultInstance = axios.create({
  baseURL: process.env.REACT_APP_API,

});

export default defaultInstance;